export default {"src":"/_next/static/media/SquareButton.fbaa8d5a.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};